import React from "react";
import { Box, Grid } from "@mui/material";
import { makeSureIsArray } from "../../functions/general";
import NunitoText from "../general/NunitoText";
import ReusableButton from "../general/ReusableButton";
export default function ConfirmModal({
  table = [],
  id,
  selected = [],
  confirmFunction,
  cancelConfirm,
  action,
  message,
  itemName,
}) {
  const selectedRows =
    table && selected && selected.length > 0
      ? selected[0]?.id !== undefined
        ? makeSureIsArray(table?.data).filter((s) =>
            id === "" ? selected.includes(s.id) : s.id === id
          )
        : makeSureIsArray(table.data).filter((s) =>
            id === "" ? selected.includes(s.index_no) : s.index_no === id
          )
      : [];
  console.log(selectedRows);
  return (
    <Box className="popUpModal" style={{ width: 705, minHeight: 310 }}>
      <NunitoText
        value="CONFIRM SUBMIT?"
        fontSize={30}
        fontWeight={600}
        color="var(--color-primary)"
        marginTop={30}
      />
      <NunitoText
        value={message || `Are you sure you want to ${action}`}
        fontSize={20}
        fontWeight={600}
      />
      {selectedRows.length > 0 &&
        selectedRows.map((s, i) => (
          <NunitoText
            key={i}
            value={`${s.name}${i < selectedRows.length - 1 && ", "}`}
            fontSize={20}
            fontWeight={700}
          />
        ))}
      {itemName && selectedRows.length === 0 && (
        <NunitoText value={itemName} fontSize={20} fontWeight={700} />
      )}
      <Grid
        container
        justifyContent="space-evenly"
        style={{ marginBlock: "30px 20px" }}
      >
        <ReusableButton
          text="Cancel"
          bgColor="var(--color-surface)" color="var(--color-primary)" borderColor="var(--color-border-strong)"
          fontSize={25}
          height={63}
          width={280}
          onClick={() => cancelConfirm()}
        />
        <ReusableButton
          text="Confirm"
          bgColor="var(--color-primary)"
          fontSize={25}
          height={63}
          width={280}
          onClick={() => confirmFunction()}
        />
      </Grid>
    </Box>
  );
}
